<template>
    <div class="h-full min-h-full flex flex-col min-w-[300px]">
        <div class="relative p-5 flex-1 overflow-y-auto">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-x-3">
                    <p class="font-bold">CRESiteIQ&trade; Scoring</p>
                    <div title="Filters">
                        <v-popover offset="5">
                            <button class="underline text-blue-600 text-xs font-semibold">
                                Filters
                            </button>

                            <template slot="popover">
                                <div class="flex flex-col p-2 min-w-[200px]">
                                    <h2 class="font-bold">Filters</h2>

                                    <div class="mt-3 flex flex-col gap-y-2">
                                        <label for="min_score_filter" class="block text-sm/6 mb-0 font-medium text-gray-900">Minimum Score</label>
                                        <div class="flex items-center gap-x-3">
                                            <input
                                                @change="$store.dispatch('filterByScore')"
                                                v-model="creSiteIQ.minScore"
                                                type="range"
                                                min="0"
                                                max="100"
                                                step="5"
                                            />
                                            <span class="text-sm text-gray-900 font-semibold">{{ creSiteIQ.minScore }}%</span>
                                        </div>
                                    </div>

                                    <a class="mt-10 text-center hover:cursor-pointer" v-close-popover>Close</a>
                                </div>
                            </template>
                        </v-popover>
                    </div>
                </div>
                <button
                    id="toggle-cresiteiq-button"
                    type="button"
                    @click="$store.dispatch('hideCRESiteIQWindow')"
                    class="hover:cursor-pointer"
                >
                    <inline-svg name="close" classes="w-3 h-3 fill-current"></inline-svg>
                </button>
            </div>

            <div v-if="reatlas.mapLoading">
                <inline-svg name="loading" />
            </div>

            <div v-else>
                <div v-if="creSiteIQ.visibleFeatures.length" class="mt-3 flex flex-col gap-y-1 divide-gray-100 divide-y">
                    <div v-if="creSiteIQ.boundary == 'state' && creSiteIQ.selectedMetrics.length">
                        <div
                            v-for="(feature, featureIndex) in featuresWithMetricData" :key="featureIndex"
                            class="p-3 flex items-center justify-between odd:bg-gray-100 hover:cursor-pointer hover:bg-yellow-50"
                            @click="openInfoWindow(feature)"
                            @mouseover="$store.dispatch('highlightFeature', feature)"
                            @mouseout="$store.dispatch('resetFeatureStyle', feature)"
                        >
                            <span class="text-lg font-semibold" v-text="feature.getProperty('NAME')"></span>

                            <div class="rounded-md p-2 text-lg font-bold text-gray-900" :style="{ backgroundColor: feature.getProperty('color') }">
                                {{ feature.getProperty('score') }}%
                            </div>
                        </div>
                    </div>
                    <div v-if="creSiteIQ.boundary == 'zip'">
                        <div
                            v-for="(feature, featureIndex) in creSiteIQ.visibleFeatures" :key="featureIndex"
                            class="p-3 flex items-center justify-between odd:bg-gray-100 hover:cursor-pointer hover:bg-yellow-50"
                            @click="openInfoWindow(feature)"
                            @mouseover="$store.dispatch('highlightFeature', feature)"
                            @mouseout="$store.dispatch('resetFeatureStyle', feature)"
                        >
                            <div class="flex flex-col">
                                <span class="text-lg font-semibold" v-text="feature.getProperty('metricData') ? feature.getProperty('metricData')['zip'] : ''"></span>
                                <div class="text-sm">
                                    <span v-text="feature.getProperty('metricData')['city']"></span>, <span v-text="feature.getProperty('metricData')['state']['state']"></span>
                                </div>
                            </div>
                            <div class="rounded-md p-2 text-lg font-bold text-gray-900" :style="{ backgroundColor: feature.getProperty('color') }">
                                {{ feature.getProperty('score') ?? 0 }}%
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5" v-if="creSiteIQ.selectedMetrics.length && creSiteIQ.visibleFeatures.length == 0">
                    <span class="text-sm text-gray-600 font-medium">No areas meet your criteria</span>
                </div>

                <div class="mt-5" v-if="creSiteIQ.selectedMetrics.length == 0">
                    <span class="text-sm text-gray-600 font-medium">Apply filters to score areas</span>
                </div>
            </div>
        </div>
        <div class="flex items-center justify-around p-3 building-title-bar text-white border-t border-gray-300 leading-normal">
            <div class="flex flex-col items-center">
                <p class="text-2xl font-semibold">{{ creSiteIQ.visibleFeatures.length }}</p>
                <p class="text-sm">Areas</p>
            </div>
            <div class="flex flex-col items-center">
                <p class="text-2xl font-semibold">{{ isNaN(averageScore) ? '-' : averageScore + "%" }}</p>
                <p class="text-sm">Average Score</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import InlineSvg from "../InlineSvg";
    import '@preline/range-slider';

    export default {
        components: {InlineSvg},

        computed: {
            featuresWithMetricData() {
                // Was a v-if on the same element as the v-for. Vue 2 filtered the list
                // anyway; doing it here survives the Vue 3 priority change.
                return (this.creSiteIQ.visibleFeatures || []).filter(feature => feature.getProperty('metricData'));
            },

            ...mapState(['reatlas']),
            ...mapState(['creSiteIQ']),

            averageScore() {
                let average = _.meanBy(this.creSiteIQ.visibleFeatures, (row) => {
                    return row.getProperty('score') == undefined
                        ? 0
                        : row.getProperty('score')
                });

                return average.toFixed(0);
            }
        },

        methods: {
            openInfoWindow(feature) {
                this.reatlas.infoWindow.close();
                this.$store.dispatch('resetFeatureStyle', feature);
                this.$store.dispatch('toggleInfoWindow', feature);
            }
        }
    }
</script>
